import React, { forwardRef } from "react";
import IBuildrProps from "../../utilities/IBuildrProps";
import classNames from "classnames";
import ReCAPTCHA from "react-google-recaptcha";

interface IReCaptchaProps extends IBuildrProps {
    onChange: (value: string) => void;
}

const ReCaptcha = forwardRef((props: IReCaptchaProps, ref: any) => {
    const { cmsId, editorClassObj, onChange } = props;

    return (
        <div data-id={cmsId} className={classNames(editorClassObj)} ref={ref}>
            <ReCAPTCHA
                sitekey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
                onChange={onChange}
            />
        </div>
    )
});

export default ReCaptcha;